import React from 'react';
import { ControlLabel } from 'react-bootstrap';
import HelpPopover from '../HelpPopover';

function CalculatorGroup({ children, ...inputProps }) {
  return (
    <div className="calculator-group">
      {inputProps.label && (<ControlLabel>{inputProps.label}</ControlLabel>)}
      {inputProps.popover && <HelpPopover popover={inputProps.popover} />}
      {inputProps.subLabel && (<div className="sub-label">{inputProps.subLabel}</div>)}
      {children}
    </div>
  )
}

export default CalculatorGroup



// WEBPACK FOOTER //
// ./src/components/CalculatorGroup/index.js